<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-carousel>
                <v-carousel-item
                    v-for="preview in previews"
                    :key="preview.pageNumber"
                    :src="getPreviewImageUrl(preview)"
                    contain
                />
            </v-carousel>
        </v-card>
    </v-dialog>
</template>

<script>
import { apiConfig } from '@/config'

export default {
    name: 'OrderDataPreviewsDialog',

    props: {
        isOpen: {
            type: Boolean
        },
        previews: {
            type: Array,
            default: null
        }
    },

    methods: {       
        getPreviewImageUrl(image) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            return `${mediaRoot}${image.path}`
        },

        onClose() {
            this.$emit('on-close')
        },
    }
}
</script>